"use client";

import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import Header from "../../../components/headerV2";
import { QueueRegistrationForm } from "@/components/queue/QueueRegistrationForm";
import { ProfilePageContent } from "@/components/profile/ProfilePageContent";
import Footer from "@/components/footer";
import BottomMenu from "@/components/bottomMenu";
import {
  clearCadastroProfile,
  saveCadastroProfile,
} from "@/services/cadastroSession";
import { setStoredState } from "@/services/stateStorage";

export default function Home() {
  const params = useSearchParams();
  const [storedEmail, setStoredEmail] = useState<string | null | undefined>(
    undefined,
  );

  const city = params.get("city") || params.get("cidade");

  useEffect(() => {
    let isMounted = true;

    if (city) {
      setStoredState(city);
    }

    const targets = document.querySelectorAll<HTMLElement>(
      ".reveal-up, .reveal-scale, .float-soft",
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        // Large sections on mobile may never reach 20% visible at once.
        threshold: 0.05,
        rootMargin: "0px 0px -5% 0px",
      },
    );

    targets.forEach((target) => observer.observe(target));

    async function syncCadastroSession() {
      try {
        const response = await fetch("/api/cadastro/me", {
          credentials: "include",
          cache: "no-store",
        });

        const data = await response.json();

        if (!isMounted) return;

        if (!response.ok) {
          clearCadastroProfile();
          setStoredEmail(null);
          return;
        }

        saveCadastroProfile(data.user);
        setStoredEmail(data.user.email);
      } catch {
        if (!isMounted) return;

        clearCadastroProfile();
        setStoredEmail(null);
      }
    }

    void syncCadastroSession();

    return () => {
      isMounted = false;
      observer.disconnect();
    };
  }, [city]);

  return (
    <div className="site-shell pb-[calc(env(safe-area-inset-bottom)+104px)]">
      <Header />
      <div style={{ height: 120 }} />
      {storedEmail === undefined ? null : storedEmail ? (
        <ProfilePageContent initialEmail={storedEmail} />
      ) : (
        <QueueRegistrationForm />
      )}
      <BottomMenu />
      <Footer />
    </div>
  );
}
